import { useFormikContext } from 'formik';

import TransactionBatchTime from 'components/admin/pages/Practices/Settings/components/components/TransactionBatchTime';
import Allowed from 'components/shared/Permissions/Allowed';

const TransactionBatchTimeWrapper = ({ practice, setPractice }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <Allowed requiredPermissions="batch_time.edit">
      <div className="flex w-full flex-col items-center justify-between gap-5 border-b border-l-0 border-r-0 border-t-0 border-solid border-b-neutral-100 pb-10 pt-5">
        <div className="flex w-full flex-col gap-5 text-sm">
          <span className="font-500">Transaction Batch Time</span>
        </div>
        <TransactionBatchTime
          practice={practice}
          updatePractice={(practice) => {
            setPractice(practice);
            setFieldValue('displaySettings', practice.display_settings);
          }}
        />
      </div>
    </Allowed>
  );
};

export default TransactionBatchTimeWrapper;
